import React from 'react';
import DealListingOwnerRow from './DealListingOwnerRow';

export default function MyDealListingsSection({ listings = [], loading = false }) {
  if (loading && listings.length === 0) {
    return (
      <section className="mb-8">
        <h2 className="font-mono text-[11px] uppercase text-muted-foreground tracking-wide mb-3">
          Your listings
        </h2>
        <div className="space-y-2">
          {[0, 1].map((i) => (
            <div key={i} className="h-[60px] bg-card border border-border rounded-[12px] animate-pulse" />
          ))}
        </div>
      </section>
    );
  }

  if (listings.length === 0) {
    return (
      <section className="mb-8">
        <p className="text-[12px] text-muted-foreground/60">
          You haven't listed anything yet.
        </p>
      </section>
    );
  }

  return (
    <section className="mb-8">
      <h2 className="font-mono text-[11px] uppercase text-muted-foreground tracking-wide mb-3">
        Your listings ({listings.length})
      </h2>
      <div className="space-y-2">
        {listings.map((listing) => (
          <DealListingOwnerRow key={listing.id} listing={listing} />
        ))}
      </div>
    </section>
  );
}
